import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Paper,
  Typography,
  Divider,
  TableContainer,
} from "@material-ui/core";
import { formatAmount } from "utils/Utils";
import Table from "components/UpdateUi/Table/Table";
import { loanSchemeDetailTable } from "assets/properties/properties";

const styles = {
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    boxShadow: "none",
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 24,
  },
  label: {
    fontSize: 13,
    color: "#6B7280",
    marginBottom: 4,
    fontWeight: 500,
  },
  value: {
    fontSize: 15,
    fontWeight: 600,
    color: "#1F2937",
  },
  item: {
    marginBottom: 24,
  },
};

const Field = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={3}>
    <div style={styles.item}>
      <Typography style={styles.label}>{label}</Typography>
      <Typography style={styles.value}>
        {value || "NA"}
      </Typography>
    </div>
  </Grid>
);

const LoanDetailsReview = ({ loanDetails, eligibleAmountDetails }) => {
  const [installments, setInstallments] = useState([]);

  useEffect(() => {
    if (loanDetails?.loanSchemeCalculation) {
      parseIndicatorData(loanDetails.loanSchemeCalculation);
    }
  }, [loanDetails]);

  const parseIndicatorData = (data) => {
    const reportData =
      data?.map((item) => ({
        adjustment: item?.adjustment,
        adjustedAmount: formatAmount(item?.adjustedAmount),
        adjustedAmountWithoutGst: formatAmount(
          item?.adjustedAmountWithoutGst
        ),
        cgstAmount: formatAmount(item?.cgstAmount),
        chargeType: item?.chargeType,
        excludingGst: item?.excludingGst,
        gstApplicable: item?.gstApplicable,
        igstAmount: formatAmount(item?.igstAmount),
        sgstAmount: formatAmount(item?.sgstAmount),
      })) || [];

    setInstallments(reportData);
  };

  return (
    <Paper style={styles.card}>
      <Typography style={styles.title}>
        Loan Details
      </Typography>

      <Grid container spacing={2}>
        <Field
          label="Eligible Loan Amount"
          value={formatAmount(eligibleAmountDetails)}
        />

        <Field
          label="Loan Amount"
          value={formatAmount(loanDetails?.loanAmount)}
        />

        <Field
          label="Interest Rate"
          value={
            loanDetails?.interestRate
              ? `${loanDetails.interestRate}%`
              : "NA"
          }
        />

        <Field
          label="Tenure (Months)"
          value={loanDetails?.tenure}
        />

        <Field
          label="Total Charges"
          value={formatAmount(loanDetails?.totalCharges)}
        />

        <Field
          label="Total GST"
          value={formatAmount(loanDetails?.totalGst)}
        />

        <Field
          label="Total Interest"
          value={formatAmount(loanDetails?.totalInterest < 0 ? loanDetails?.totalInterest * -1 : loanDetails?.totalInterest)}
        />

        <Field
          label="Net Disbursal Amount"
          value={formatAmount(loanDetails?.netDisbursalAmount)}
        />
      </Grid>

      {installments.length > 0 && (
        <>
          <Divider style={{ margin: "20px 0" }} />

          <Typography
            style={{
              fontSize: 18,
              fontWeight: 600,
              marginBottom: 16,
              color: "#1E3A5F",
            }}
          >
            Charge Breakdown
          </Typography>

          <TableContainer
            style={{
              border: "1px solid #E5E7EB",
              borderRadius: 8,
            }}
          >
            <Table
              columns={loanSchemeDetailTable}
              rows={installments}
              styles="style"
              noPagination
            />
          </TableContainer>
        </>
      )}
    </Paper>
  );
};

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
};

LoanDetailsReview.propTypes = {
  loanDetails: PropTypes.object,
  eligibleAmountDetails: PropTypes.any,
};

export default LoanDetailsReview;